import { AnimatePresence } from 'motion/react';
import type { ReactNode } from 'react';
import { ConnectionBanner } from '@/features/room-lobby/ui/ConnectionBanner';
import { Toaster } from '@/shared/components/Toaster';
import { useSessionStore } from '@/shared/hooks/use-shallow-store';
import { DriverMode } from '@/shared/lib/driver';

/** App-wide mount for ConnectionBanner — must persist across navigation so reconnect state isn't dropped. */
export const ConnectionStatusProvider = ({ children }: { children: ReactNode }) => {
  const mode = useSessionStore((s) => s.mode);
  const isOnline = mode === DriverMode.Online;
  return (
    <>
      {children}
      {isOnline && (
        <>
          <div
            aria-live="polite"
            className="pointer-events-none fixed inset-x-0 top-2 z-50 flex justify-center px-3"
          >
            <AnimatePresence mode="wait">
              <ConnectionBanner key="conn-banner" />
            </AnimatePresence>
          </div>
          <Toaster />
        </>
      )}
    </>
  );
};
